import React from 'react'
import { FiChevronsRight } from 'react-icons/fi'
import { CampanhaBoard } from '../style'
import { maskDate } from 'util/masks'
import useRedux from 'hooks/useRedux'
import * as inicioActions from 'store/modules/inicio/actions'
import PrivateComponent from 'components/PrivateComponent'

interface Props {
  id: string
  nomeCampanha: string
  dataInicial: string
  dataFinal: string
  tipoOperacao: string
  totalClientes: number
  totalClientesAcionar: number
  conversao: string
  ligacoesRecebidas: number
  ligacoesPerdidas: number
  cpc: number
  nomeLoja: string
  descricaoTipoCampanha: string
  paused?: boolean
  codigoCampanhaDiscador?: string
}

function CardCampanha({
  id,
  nomeCampanha,
  dataInicial,
  dataFinal,
  tipoOperacao,
  totalClientes,
  totalClientesAcionar,
  conversao,
  ligacoesRecebidas,
  ligacoesPerdidas,
  cpc,
  nomeLoja,
  descricaoTipoCampanha,
  paused = true,
  codigoCampanhaDiscador: campanhaAutomaticaId
}: Props) {
  const { dispatch } = useRedux()

  const isAutomatica = ['URA', 'DISCADOR'].includes(
    descricaoTipoCampanha?.toUpperCase() || ''
  )

  const acaoBotao = () => {
    if (isAutomatica && campanhaAutomaticaId) {
      dispatch(
        inicioActions.alternarStatusCampanhaSaga(campanhaAutomaticaId, !paused)
      )
    } else if (!isAutomatica) {
      dispatch(inicioActions.iniciarAtendimentoCampanhasSaga(id))
    }
  }

  const descricaoBotao = () => {
    if (isAutomatica) {
      return paused ? 'Iniciar' : 'Pausar'
    }
    return 'Iniciar'
  }

  return (
    <CampanhaBoard>
      <section className="informacoes-campanha">
        <div className="d-flex flex-column align-items-lg-start">
          <div className="titulo-campanha">{nomeCampanha}</div>
          <div>
            Inicio:&nbsp;
            <span className="green-text md">
              {maskDate(dataInicial, 'DD/MM/YYYY')}
            </span>
          </div>
          <div>
            Final:&nbsp;
            <span className="green-text md">
              {maskDate(dataFinal, 'DD/MM/YYYY')}
            </span>
          </div>
          <div>
            Ligações Recebidas:&nbsp;
            <span>{ligacoesRecebidas}</span>
          </div>
          <div>
            Ligações Perdidas:&nbsp;
            <span>{ligacoesPerdidas}</span>
          </div>
          <div>
            Loja: <span>{nomeLoja}</span>
          </div>
          <div className="destaque-negrito">
            <b>
              Tipo operação: <span>{tipoOperacao}</span>
            </b>
          </div>
          <div className="destaque-negrito">
            <b>
              Tipo Campanha: <span>{descricaoTipoCampanha}</span>
            </b>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-around">
          <div className="d-flex flex-column align-items-center">
            <span className="purple-text lg">
              {totalClientesAcionar}/{totalClientes}
            </span>
            T. Clientes:
          </div>
          <div className="d-flex flex-column align-items-center">
            <span className="purple-text lg">{cpc}</span>
            CPC:
          </div>
          <div className="d-flex flex-column align-items-center">
            <span className="purple-text lg">{conversao}</span>Conversão:
          </div>
        </div>
      </section>
      <div className="d-flex justify-content-center align-content-center m-2">
        {isAutomatica ? (
          <PrivateComponent screen="inicio" typeActions="iniciarPausar">
            <button
              onClick={acaoBotao}
              role="button"
              disabled={false}
              className="btn-outline-purple"
            >
              {descricaoBotao()} <FiChevronsRight />
            </button>
          </PrivateComponent>
        ) : (
          <button
            onClick={acaoBotao}
            role="button"
            disabled={totalClientesAcionar <= 0}
            className="btn-outline-purple"
          >
            {descricaoBotao()} <FiChevronsRight />
          </button>
        )}
      </div>
    </CampanhaBoard>
  )
}

export default CardCampanha
